import { Component } from "@theme/component";

/**
 * Markenbotschafterinnen — Übersicht.
 *
 * Filtert die bereits gerenderten Karten nach Postleitzahl. Kein Nachladen:
 * es sind 16 Karten, die ohnehin alle auf der Seite stehen.
 *
 * Fachliche Regel: die ERSTE Ziffer der PLZ ist das PLZ-Gebiet, und danach
 * sind die Botschafterinnen eingeteilt. Wer „72131“ eingibt, sieht Gebiet 7.
 * Bei vollständiger Eingabe werden die Karten des Gebiets zusätzlich nach
 * numerischer Nähe sortiert, damit die nächstgelegene oben steht — das ist
 * die eigentliche Frage der Besucherin („wer ist in meiner Nähe?“) und nicht
 * „in welchem Postleitzahlengebiet wohne ich?“.
 */
class LbrgtMarkenbotschafter extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.karten = Array.from(this.querySelectorAll(".lbrgt-mb__karte"));
    this.gruppen = Array.from(this.querySelectorAll(".lbrgt-mb__gruppe"));

    this.#statusSchreiben(this.dataset.gesamtText, this.karten.length);
  }

  /* -------------------------------------------------------------- Filter */

  filtern(event) {
    // event.target — das Theme reicht Handler über einen globalen Listener nach.
    const roh = event.target.value;
    const ziffern = roh.replace(/\D/g, "");

    // Nicht-Ziffern gar nicht erst stehen lassen; das Feld ist type="text",
    // weil type="number" führende Nullen frisst (01067 ist eine gültige PLZ).
    if (roh !== ziffern) event.target.value = ziffern;

    this.refs.zuruecksetzen?.toggleAttribute("hidden", ziffern === "");

    if (ziffern === "") {
      this.#allesZeigen();
      return;
    }

    const gebiet = ziffern[0];
    let sichtbar = 0;

    for (const gruppe of this.gruppen) {
      const passt = gruppe.dataset.gebiet === gebiet;
      gruppe.hidden = !passt;
      if (passt) sichtbar += gruppe.querySelectorAll(".lbrgt-mb__karte").length;
    }

    // Vollständige PLZ: nach Nähe sortieren und die exakte Übereinstimmung
    // hervorheben. Über CSS `order`, damit das Raster nicht neu gebaut wird.
    const vollstaendig = ziffern.length === 5;
    const eingabe = vollstaendig ? Number(ziffern) : null;

    for (const karte of this.karten) {
      const plz = karte.dataset.plz;
      const treffer = vollstaendig && plz === ziffern;
      karte.classList.toggle("is-treffer", treffer);

      if (!vollstaendig) {
        karte.style.order = "";
        continue;
      }
      // Karten ohne gepflegte PLZ ans Ende ihres Gebiets.
      const abstand = plz ? Math.abs(Number(plz) - eingabe) : Number.MAX_SAFE_INTEGER;
      karte.style.order = String(Math.min(abstand, 99999));
    }

    const nichts = this.refs.nichts;
    if (nichts) {
      nichts.hidden = sichtbar > 0;
      if (sichtbar === 0) nichts.textContent = this.dataset.leerText;
    }

    this.#statusSchreiben(sichtbar > 0 ? this.dataset.trefferText : "", sichtbar);
  }

  zuruecksetzen() {
    const feld = this.refs.feld;
    if (feld) {
      feld.value = "";
      feld.focus();
    }
    this.#allesZeigen();
    this.refs.zuruecksetzen?.setAttribute("hidden", "");
  }

  /* -------------------------------------------------------------- Intern */

  #allesZeigen() {
    for (const gruppe of this.gruppen) gruppe.hidden = false;
    for (const karte of this.karten) {
      karte.classList.remove("is-treffer");
      karte.style.order = "";
    }
    if (this.refs.nichts) this.refs.nichts.hidden = true;
    this.#statusSchreiben(this.dataset.gesamtText, this.karten.length);
  }

  #statusSchreiben(vorlage, anzahl) {
    const el = this.refs.status;
    if (!el) return;
    el.textContent = vorlage ? vorlage.replace("[anzahl]", anzahl) : "";
  }
}

if (!customElements.get("lbrgt-markenbotschafter")) {
  customElements.define("lbrgt-markenbotschafter", LbrgtMarkenbotschafter);
}
